import { localStorageService } from '../utils/LocalStorageService';

type LastPaymentType = {
  claimId: string;
  referenceNo: string;
  inactiveAutoPayAccount?: string;
  policyNumber?: string;
};

export const useLastPayment = () => {
  const result = {
    lastPayment: undefined,
  };

  try {
    return {
      ...result,
      lastPayment: JSON.parse(localStorageService.get('LastPayment') || '') as LastPaymentType,
    };
  } catch {
    return result;
  }
};
